/* =============================================
   FOREST ART & FRAME - GLOBAL JS (Shopify port)

   Source: 04_Build_StaticSite/js/global.js

   Named ff-global.js, not global.js, because Dawn already ships an
   assets/global.js and theme assets are one flat namespace.

   Two behaviours differ from the static original, both deliberate:

     1. ACTIVE NAV LINK. The static version compared the last path segment
        against "index.html". Shopify has no .html anywhere, so the check is
        now a pathname comparison that understands /, /pages/x and
        /collections/x, and ignores the hash and query string.

     2. ARIA. The hamburger carries aria-expanded in the markup but the old
        script never updated it, and the mobile menu is a role="dialog" that
        could not be closed with Escape. Both are fixed here. Neither changes
        anything visual.
   ============================================= */

document.addEventListener('DOMContentLoaded', () => {
  /* --- MOBILE SUBMENU ACCORDIONS --- */
  document.querySelectorAll('[data-mobile-toggle]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const panel = btn.nextElementSibling;
      const open = btn.classList.toggle('open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (panel) panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '0px';
    });
  });

  /* --- NAV SCROLL STATE --- */
  const nav = document.querySelector('.nav');
  if (nav) {
    const update = () => {
      nav.classList.toggle('scrolled', window.scrollY > 20);
    };
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  /* --- MOBILE MENU --- */
  const hamburger = document.querySelector('.nav-hamburger');
  const mobileMenu = document.querySelector('.mobile-menu');
  const mobileClose = document.querySelector('.mobile-close');

  function openMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.add('open');
    if (hamburger) {
      hamburger.classList.add('open');
      hamburger.setAttribute('aria-expanded', 'true');
    }
    document.body.style.overflow = 'hidden';
  }
  function closeMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('open');
    if (hamburger) {
      hamburger.classList.remove('open');
      hamburger.setAttribute('aria-expanded', 'false');
    }
    document.body.style.overflow = '';
  }

  if (hamburger) {
    hamburger.addEventListener('click', () => {
      if (mobileMenu && mobileMenu.classList.contains('open')) closeMenu();
      else openMenu();
    });
  }
  if (mobileClose) mobileClose.addEventListener('click', closeMenu);

  // Close menu when a nav link is clicked
  document.querySelectorAll('.mobile-nav-link').forEach((link) => {
    link.addEventListener('click', closeMenu);
  });

  // Close on outside tap
  if (mobileMenu) {
    mobileMenu.addEventListener('click', (e) => {
      if (e.target === mobileMenu) closeMenu();
    });
  }

  // Close on Escape. The overlay is a role="dialog"; Escape is expected there.
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && mobileMenu && mobileMenu.classList.contains('open')) closeMenu();
  });

  /* --- ACTIVE NAV LINK ---
     Shopify paths, not filenames. "/" only matches "/" exactly, otherwise the
     homepage link would light up on every page. Everything else matches on the
     path or on a path prefix, so /collections/mirrors marks its parent
     /collections link too. Locale prefixes such as /en-za are tolerated because
     both sides are read through the same URL parser. */
  const stripTrailing = (p) => (p.length > 1 ? p.replace(/\/+$/, '') : p);
  const here = stripTrailing(window.location.pathname);

  document.querySelectorAll('.nav-link, .mobile-nav-link, .footer-link').forEach((link) => {
    const raw = link.getAttribute('href');
    if (!raw || raw === '#' || raw.charAt(0) === '#') return;

    let target;
    try {
      target = stripTrailing(new URL(raw, window.location.origin).pathname);
    } catch (err) {
      return;
    }

    const isActive =
      target === here || (target !== '/' && here.indexOf(target + '/') === 0);

    if (isActive) link.classList.add('active');
  });

  /* --- SMOOTH REVEAL ON SCROLL --- */
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add('revealed');
          observer.unobserve(e.target);
        }
      });
    },
    { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
  );

  document.querySelectorAll('.reveal').forEach((el) => observer.observe(el));
});
